import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Help = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check login status on component mount
    const token = sessionStorage.getItem('accessToken');
    setIsLoggedIn(!!token);

    // Listen for storage changes (when user logs in/out in another tab)
    const handleStorageChange = () => {
      const token = sessionStorage.getItem('accessToken');
      setIsLoggedIn(!!token);
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Also check periodically in case of same-tab changes
    const interval = setInterval(() => {
      const token = sessionStorage.getItem('accessToken');
      setIsLoggedIn(!!token);
    }, 1000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card">
          <div className="card-header" style={{backgroundColor: "var(--color-primary-green)"}}>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="card-title text-white">🆘 Morvi Bazaar Help Center</h4>
                <p className="text-white mb-0">Welcome to the official Help Center of Morvi Bazaar – India's leading B2B platform for Tiles & Sanitaryware, connecting verified Buyers and Sellers directly from Morbi, Gujarat.</p>
              </div>
              {!isLoggedIn && (
                <div className="d-flex gap-2">
                  <Link to="/login" className="btn btn-sm" style={{backgroundColor: '#ffffff', color: 'var(--color-primary-green)', border: '1px solid #ffffff'}}>
                    <i className="fe fe-log-in me-1"></i> Login
                  </Link>
                  <Link to="/signup" className="btn btn-sm" style={{backgroundColor: 'var(--color-primary-green)', color: '#ffffff', border: '1px solid #ffffff'}}>
                    <i className="fe fe-user-plus me-1"></i> Sign Up
                  </Link>
                </div>
              )}
            </div>
          </div>
          <div className="card-body">
            <div className="help-content">
              
              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>📲 For Buyers (Mobile App Users)</h5>
                
                <div className="faq-item mb-3">
                  <h6 className="text-secondary">1. Who can use the Morvi Bazaar app?</h6>
                  <p>Only dealers/shop owners with a valid GST number can register and subscribe.</p>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">2. How do I register on the app?</h6>
                  <ul>
                    <li>Download the app from Google Play or App Store</li>
                    <li>Sign up using your mobile number & OTP</li>
                    <li>Enter your firm name, GST number, and address</li>
                    <li>Once verified, choose a subscription plan to access listings</li>
                  </ul>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">3. Why do I need a subscription?</h6>
                  <p>Only subscribed buyers can:</p>
                  <ul>
                    <li>View seller stock and profiles</li>
                    <li>Contact sellers directly via WhatsApp</li>
                  </ul>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">4. What do I get as a subscriber?</h6>
                  <ul>
                    <li>✅ Real-time stock updates</li>
                    <li>✅ Verified seller listings</li>
                    <li>✅ Direct inquiries without commission</li>
                    <li>✅ Factory prices in one place</li>
                    <li>✅ Detailed seller profiles & catalogs</li>
                  </ul>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">5. Can I post what I want to buy?</h6>
                  <p>Yes. Use the "Post Requirement" feature (free for all users). Your requirement will be forwarded to relevant sellers manually by our team.</p>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">6. How do I contact a seller?</h6>
                  <p>Each listing/profile includes a WhatsApp button. Tap it to connect instantly with the seller.</p>
                </div>
              </section>

              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>🧑‍💼 For Sellers (Website Users)</h5>
                
                <div className="faq-item mb-3">
                  <h6 className="text-secondary">1. Who can become a seller?</h6>
                  <p>Only manufacturers and super stockists based in Morbi, Gujarat, with a valid GST number.</p>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">2. How do I register as a seller?</h6>
                  <ul>
                    <li>Visit 👉 <a href="https://seller.morvibazaar.com/" target="_blank" rel="noopener noreferrer">https://seller.morvibazaar.com/</a></li>
                    <li>Click "Join as Seller"</li>
                    <li>Enter firm details, GST, and contact info</li>
                    <li>Choose your subscription plan</li>
                    <li>Start uploading stock lists (PDF or images)</li>
                  </ul>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">3. Where will my stock be visible?</h6>
                  <p>Your stock will be displayed inside the Morvi Bazaar buyer app to verified, subscribed buyers across India.</p>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">4. Can I create a digital profile page?</h6>
                  <p>Yes. Once subscribed, you can create a profile that works like your own mini-website, including:</p>
                  <ul>
                    <li>📌 Firm bio & contact details</li>
                    <li>📌 Product categories & logo</li>
                    <li>📌 Upload catalogs or images</li>
                    <li>📌 WhatsApp link for direct buyer chats</li>
                  </ul>
                </div>

                <div className="faq-item mb-3">
                  <h6 className="text-secondary">5. How do I get buyer inquiries?</h6>
                  <p>Buyers can message you directly via WhatsApp – no commission charged.</p>
                </div>
              </section>

              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>💳 Payments & Subscriptions</h5>
                
                <div className="help-section mb-3">
                  <h6 className="text-secondary">Payment Gateway:</h6>
                  <p>We use Razorpay for secure subscription payments.</p>
                </div>

                <div className="help-section mb-3">
                  <h6 className="text-secondary">Subscription Plans (For Buyers & Sellers):</h6>
                  <ul>
                    <li>₹999 / 1 month</li>
                    <li>₹1999 / 3 months</li>
                    <li>₹3999 / 12 months</li>
                  </ul>
                  <p><em>(Buyers subscribe via the mobile app. Sellers subscribe via the website.)</em></p>
                </div>

                <div className="help-section mb-3">
                  <h6 className="text-secondary">Refund Policy:</h6>
                  <p>All subscription payments are non-refundable. Please review features and plans carefully before subscribing.</p>
                </div>
              </section>

              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>🛡️ Account Verification & Safety</h5>
                
                <div className="help-section mb-3">
                  <ul>
                    <li>All sellers are manually verified before their listings go live.</li>
                    <li>Buyers must submit GST details and are verified before getting full access.</li>
                    <li>Our team monitors listings and reviews to prevent fraud.</li>
                  </ul>
                </div>

                <div className="help-section mb-3">
                  <h6 className="text-secondary">Report Abuse:</h6>
                  <p>If you find any fake or misleading listing, 📩 email us at: <a href="mailto:info@morvibazaar.com">info@morvibazaar.com</a></p>
                </div>
              </section>

              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>☎️ Customer Support</h5>
                <p>Have questions or facing issues? We're here to help.</p>
                
                <div className="contact-methods">
                  <div className="contact-method mb-3">
                    <h6 className="text-secondary">📞 Customer Care Numbers:</h6>
                    <p><strong>+91 76000 90040, +91 99989 98090</strong></p>
                    <p><strong>Hours:</strong> Mon–Sat, 10 AM – 7 PM</p>
                  </div>

                  <div className="contact-method mb-3">
                    <h6 className="text-secondary">📧 Email:</h6>
                    <p><a href="mailto:info@morvibazaar.com">info@morvibazaar.com</a></p>
                  </div>

                  <div className="contact-method mb-3">
                    <h6 className="text-secondary">🌐 Websites:</h6>
                    <ul>
                      <li>Common Website: <a href="https://www.morvibazaar.com" target="_blank" rel="noopener noreferrer">www.morvibazaar.com</a></li>
                      <li>Seller Website: <a href="https://seller.morvibazaar.com/" target="_blank" rel="noopener noreferrer">https://seller.morvibazaar.com/</a></li>
                    </ul>
                  </div>
                </div>
              </section>

              <section className="mb-4">
                <h5 style={{color: 'var(--color-primary-green)'}}>🔗 Quick Links</h5>
                <div className="quick-links">
                  <div className="row">
                    <div className="col-md-6">
                      <div className="link-item mb-2">
                        <strong>📲 Buyer App:</strong> <a href="#" target="_blank" rel="noopener noreferrer">[Google Play]</a> | <a href="#" target="_blank" rel="noopener noreferrer">[App Store]</a>
                      </div>
                      <div className="link-item mb-2">
                        <strong>🌐 Seller Registration:</strong> <a href="https://seller.morvibazaar.com/" target="_blank" rel="noopener noreferrer">https://seller.morvibazaar.com/</a>
                      </div>
                      <div className="link-item mb-2">
                        <strong>🌐 Main Website:</strong> <a href="https://www.morvibazaar.com" target="_blank" rel="noopener noreferrer">www.morvibazaar.com</a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;
